import JSONInput from 'react-json-editor-ajrm'
import locale from 'react-json-editor-ajrm/locale/en'
import { Label } from './common/label'
import { useForm } from './form'
import {  useMemo } from 'react'

export const FormSimpleJsonEditor = ({ name, label, required }) => {
  const { register, getValue, setValue, getError, setError, clearError } = useForm(name, { shouldDirty: true})

  let value = getValue()
  let error = getError()

  let jsonValue = useMemo(
    () => {
      try {
        return JSON.parse(value)
      } catch {
        return {}
      }
    },
    [value]
  )

  const handleChange = ({ jsObject, error }) => {
    
    if (error) {
      setError('Invalid JSON Format')
      return
    }

    clearError()

    try {
      let value = JSON.stringify(jsObject)
      setValue(value)
    } catch {}
  }

  return (
    <Label name={name} label={label} required={required}>
      <div className="border rounded p-1">
        <input type='hidden' {...register()} />
        <JSONInput
              placeholder={jsonValue}
              locale={locale}
              waitAfterKeyPress={3000}
              width="100%"
              height="100%"
              theme="light_mitsuketa_tribute"
              onBlur={handleChange}
            />
            
      </div>
      <div>
          {error && <small className='text-danger'>{error}</small>}
      </div>
    </Label>
  )
}
